module.exports = __webpack_public_path__ + "static/media/Invoice.1add4e8a.jpg";